import { css } from "@emotion/react"

export const menuContainerStyle = css`
	max-height: 40rem;
	overflow-y: auto;

	li {
		margin-bottom: 1rem;

		a {
			width: 17rem;
			display: inline-block;
			padding: 0.8rem;
			background: none;
			border: 0;
			color: #003264;
			font-weight: normal;
			font-size: 1rem;
			text-decoration: none !important;
			font-weight: 500;

			&:hover {
				background: #0b75e1;
				color: white !important;
			}
		}
	}
`
export const navItemListStyle = () => css`
	break-inside: avoid-column;
	padding: 1.5rem;
`
